import { MESSENGER_PERMISSION } from "@/config/permission-keys";
import { useFeaturesV2 } from "@/hooks/useFeaturesV2";
import { isMessengerEnabled } from "@/utils/feature-flags";

export { MESSENGER_PERMISSION };

/**
 * Whether the messenger feature is available to the signed-in practitioner's organization.
 *
 * Messenger is on only when the environment flag allows it AND the practitioner's
 * featuresv2 carries `messenger:UseChat`. The check fails closed: while the permissions
 * query is loading, errored or empty, `enabled` is false, so no messenger UI shows and no
 * messenger login or XMPP connection starts until the permission is known.
 *
 * @returns `enabled` plus `loading`, true while the permissions query is still in flight
 */
export const useMessengerEnabled = (): { enabled: boolean; loading: boolean } => {
  const { hasFeature, isLoading } = useFeaturesV2();

  return {
    enabled: isMessengerEnabled() && hasFeature(MESSENGER_PERMISSION),
    loading: isLoading,
  };
};
